/// <reference lib="webworker" />

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Content, StyleDictionary, TableCell, TDocumentDefinitions } from 'pdfmake/interfaces';

import { fetchLogoAsDataUrl } from '@shared/utils/logo';

export interface PdfExportWorkerParams {
  columnLength: number;
  customStyles?: StyleDictionary;
  tableBody: TableCell[][];
}

const FIRST_PAGE = 1;

export const NO_BORDERS = {
  border: [false, false, false, false],
};

onmessage = async ({ data }: MessageEvent<PdfExportWorkerParams>) => {
  const { columnLength, customStyles = {}, tableBody } = data;

  if (!tableBody || !Array.isArray(tableBody) || tableBody.length === 0) {
    return;
  }

  const logoBlob = await fetchLogoAsDataUrl('/assets/img/logo-dark-2.png');

  const defaultStyles: StyleDictionary = {
    header: {
      bold: true,
      fontSize: 18,
      margin: [0, 0, 0, 10],
    },
    tableCell: {
      alignment: 'left',
      fontSize: 10,
      margin: 5,
    },
    tableHeader: {
      alignment: 'center',
      bold: true,
      color: 'white',
      fillColor: '#094673',
      fontSize: 11,
    },
    trialHeaderRow: {
      bold: true,
      color: 'white',
      fillColor: 'gray',
    },
  };

  const finalDocDefinition: TDocumentDefinitions = {
    content: [
      {
        marginTop: 70,
        table: {
          body: tableBody,
          headerRows: 0,
          widths: Array(columnLength).fill(`${100 / columnLength}%`),
        },
      } as Content,
    ],
    defaultStyle: {
      font: 'Roboto',
    },
    header: (currentPage) => {
      return currentPage === FIRST_PAGE
        ? {
            image: logoBlob,
            margin: [20, 20],
            width: 200,
          }
        : undefined;
    },
    pageMargins: [20, 20, 20, 20],
    pageOrientation: 'landscape',
    styles: { ...defaultStyles, ...customStyles },
  };

  const pdfDocGenerator = pdfMake.createPdf(finalDocDefinition, undefined, undefined, pdfFonts.vfs);

  pdfDocGenerator.getBlob((blob) => {
    postMessage({ blob });
  });
};
